export default Object.freeze({
  JOB_TYPE: 'JobType',
  MEMBERSHIP: 'MembershipType',
  BOOKING_PROVIDER_TAG: 'BookingProviderTag',
  TAG: 'Tag',
  COMFORT_CREDIT_BALANCE: 'ComfortCreditBalance',
  CC_DEDUCTION: 'ComfortCreditDeduction',
  TUNEUP_JOB_TYPE: 'TuneupJobType',
});
